import { Component, OnInit } from '@angular/core';
import { ProspectService } from 'services/prospect.service';
import { Router, ActivatedRoute} from '@angular/router';
import { ProspectTourSummary } from 'app/models/prospect-tour-summary';
import { createCalendar } from 'add-to-calendar-buttons';
import { ErrorService } from 'services/error.service';
import {MatIconModule} from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ProspectOpenhouse } from 'app/models/prospect-openhouse';
import { ProspectProfileInfo } from 'app/models/prospect-profile-info';


@Component({
  selector: 'app-add-tour-to-calendar',
  templateUrl: './add-tour-to-calendar.component.html',
  styleUrls: ['./add-tour-to-calendar.component.css']
})
export class AddTourToCalendarComponent implements OnInit {
  address: string = null;
  tourType: string = null;
  tourSummary: ProspectTourSummary = new ProspectTourSummary();
  errorMessage: string = null;
  sub: any
  recordKey: number = null;
  prospectInfo: ProspectProfileInfo = new ProspectProfileInfo();
  minMoveInDate: Date = new Date();
  tourTypeText: string = null;
  tourTypeDateText: string = null;


  constructor(private prospectService: ProspectService, public router: Router, public route: ActivatedRoute) {

    let address = localStorage.getItem('PropertyAddress');
    let tourtype = localStorage.getItem('TourType');
    let recordKey = Number(localStorage.getItem('RecordKey'));
    if (address !== null && address !== undefined)
    {
      this.address = address;
    }
    if (tourtype !== null && tourtype !== undefined)
    {
      this.tourType = tourtype;
    }
    if (recordKey !== null && recordKey !== undefined)
    {
      this.recordKey = recordKey;
    }

    if (tourtype === "openhouse")
    {

      this.tourTypeText = `We look forward to seeing you at ${this.address}, for the open house scheduled`;

      this.prospectService.getOpenHouseSummary(this.recordKey).subscribe(res => this.onGetTourSummary(res), res => this.errorMessage = "Error getting open house summary.")
    }
    else if (tourtype === "showing")
    {

      this.tourTypeText = `Your showing of ${this.address} is scheduled for`;

      this.prospectService.getShowingSummary(this.recordKey).subscribe(res => this.onGetTourSummary(res), res => this.errorMessage = "Error getting showing summary.")
    }
    
    this.prospectService.getProspectProfileInfo().subscribe(res => this.onGetProspectProfileInfo(res), res => this.errorMessage = "Error getting user information.")
   }

  ngOnInit() { 
  }

  onGetTourSummary(tour: ProspectTourSummary)
  {

    if (this.tourType === "openhouse")
    {
      this.tourTypeDateText = `${tour.DateTitle} between ${tour.StartTime} and ${tour.EndTime}.`;
    }
    else if (this.tourType === "showing")
    {
      this.tourTypeDateText = `${tour.DateTitle} at ${tour.StartTime}.`;
    }

    this.tourSummary = tour;
    this.createCalendarWidget();
  }

  onGetProspectProfileInfo(info: ProspectProfileInfo)
  {
    if (info.PreferredMoveIn !== null)
    {
      this.prospectInfo.PreferredMoveIn = new Date(info.PreferredMoveIn);
    }
    else {
      this.prospectInfo.PreferredMoveIn = new Date();
    }
    
  }

  createCalendarWidget(){

    let tempTitle = null;

    if (this.tourType === "openhouse")
    {
      tempTitle = 'Open House at ' + this.address;
    }
    else if (this.tourType === "showing")
    {
      tempTitle = 'Showing at ' + this.address;
    }

    var myCalendar = createCalendar({
      data: {
        title: tempTitle,
        start: new Date(this.tourSummary.EventStart),
        end: new Date(this.tourSummary.EventEnd),     
        address: this.address,
        description: ''
      }
    });
    
    myCalendar.querySelector('label.add-to-calendar-checkbox').innerHTML = "<div class='flex justify-start items-center hover:text-true-blue'><span class='material-icons '>calendar_today</span>&nbsp;<span class='text-base hover:font-bold font-body' id='oh-summary-atc-text'>ADD TO CALENDAR</span><div>";

    document.querySelector('#selftour-cal-anchor').appendChild(myCalendar);
  }

  finish(){
    this.router.navigate(['/account/tours']);
  }
}
